"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cookies = exports.AUTHORITY = void 0;
exports.AUTHORITY = {
    HOTMART_LIVE_PROVIDER: 'HOTMART_LIVE_PROVIDER',
    HOTPRO_LEAD: 'HOTPRO_LEAD',
    HOTPRO_FREEMIUM: 'HOTPRO_FREEMIUM',
    MEM_MANAGE_PRODUCT: 'MEM_MANAGE_PRODUCT'
};
var Cookies;
(function (Cookies) {
    Cookies["UserToken"] = "hmVlcIntegration";
    Cookies["AttendantUserToken"] = "integrationBWCentral";
})(Cookies || (exports.Cookies = Cookies = {}));
